import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { /*Input,*/ AutoComplete } from 'antd'
import { DatePicker, Text, Select } from 'common/components'

const WHAT_OPTIONS = [
  // refer to Jira #372
  { value: 'legal-fee',       label: 'Legal fee' },
  { value: 'broker-fee',      label: 'Broker fee' },
  { value: 'other-fee',       label: 'Other fee' },
  { value: 'repayment',       label: 'Repayment' },
  { value: 'application-fee', label: 'Application fee' },
]
const WHY_OPTIONS = [
  { value: 'Commitment payment received on [Date on bank statement]' },
  { value: 'Equity Injection or Project Contribution' },
  { value: 'Repayment from sale proceeds of [Address]' },
  { value: 'Full Repayment' },
  { value: 'Repayment from GST Refund' },
];

const Wrapper = styled.div`
  padding: 16px;
  background-color: white;
  border: 1px solid #e6e7e9;
  border-radius: 4px;
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr 16px 40px 1fr;
  align-items: center;
  
  & ~ & {
    margin-top: 16px;
  }
  &:last-child {
    grid-template-columns: 40px 1fr;
  }

  /* & input {
    width: 100%;
  } */
`

interface IProps {
  onDateChange: (d:any) => void;
  onWhatChange: (w:string) => void;
  onWhyChange: (w:string) => void;
  targetId?: string;
}

export const EmptySlip:React.FC<IProps> = ({
  targetId,
  onDateChange, onWhatChange, onWhyChange
}) => {
  const [date, setDate] = useState(null)
  const [what, setWhat] = useState(null)
  const [why, setWhy] = useState(null)

  const onThisDateChange = (v:any) => {
    // console.log(v)
    onDateChange(v)
    setDate(v)
  }
  const onThisWhatChange = (v:any) => {
    // console.log(v)
    onWhatChange(v)
    setWhat(v)
  }
  const onThisWhyChange = (v:any) => {
    // console.log(v)
    onWhyChange(v)
    setWhy(v)
  }
  useEffect(() => {
    // console.log(targetId)
    onThisDateChange(null)
    onThisWhatChange(null)
    onThisWhyChange(null)
  }, [targetId])
  return (
    <Wrapper>
      {/*
        <Text size="xs">Who</Text>
        <Input />
      */}

      <Row>
        <Text size="xs">When</Text>
        <DatePicker // format="DD/MM/y"
          onChange={onThisDateChange}
          disabledDate={(v:Date) => !v}
          value={date}
        />
        <div></div>
        <Text size="xs">What</Text>
        <Select options={WHAT_OPTIONS} onChange={onThisWhatChange} value={what} />
      </Row>

      <Row>
        <Text size="xs">Why</Text>
        <AutoComplete options={WHY_OPTIONS} onChange={onThisWhyChange} value={why} />
      </Row>
    </Wrapper>
  )
}
